import type { IBusinessReferenceDTO } from './IBusiness';
import type { ICertificateEmployeeDTO } from './ICertificate';
import type IEntity from './IEntity';
import type { IEmployeeCoverage, ISkillLevelCompare } from './IOpportunity';
import type { IPermissions } from './IPermissions';
import type { IProductReferenceDTO } from './IProduct';
import type { IReference } from './IReference';
import type { ISkillReferenceDTO } from './ISkill';

export interface IEmployeeDTO extends IEntity {
    id: number;
    firstName: string;
    lastName: string;
    gender: EGender;
    description: string;
    email: string;
    phoneNumber?: string;
    linkedInUrl?: string;
    slackUrl?: string;
    websiteUrl?: string;
    pictureId: string | null;
    jobTitle?: string;
    certificates: ICertificateEmployeeDTO[];
    skills: ISkillReferenceDTO[];
    similarUsers: ISimilarUserDTO[];
    availability: IAvailabilityDTO;
    products: IEmployeeProductReferenceDTO[];
    projects: IEmployeeProjectReferenceDTO[];
    opportunities: IEmployeeOpportunityReferenceDTO[];
    competences: IEmployeeCompetenceReference[];
    roles: IEmployeeRoleReference[];
    salesIdea: string;
    superPowerOrder: number[];
}
export interface IAvailabilityDTO {
    availability: number;
    workDayCount: number;
}
export interface IEmployeeProductReferenceDTO extends IProductReferenceDTO {
    skillCoverage: number;
}
export interface IEmployeeRoleReference extends IReference {}
export interface IEmployeeOpportunityReferenceDTO extends IReference {
    skillCoverage: number;
    score: number;
    missingSkills: ISkillLevelCompare[];
    coveredSkills: ISkillLevelCompare[];
    missingCertificates: IReference[];
    coveredCertificates: IReference[];
    missingRoles: IReference[];
    coveredRoles: IReference[];
}
export interface IEmployeeProjectReferenceDTO extends IReference {
    business: IBusinessReferenceDTO;
    active: boolean;
}
export interface IEmployeeCompetenceReference extends IReference {
    level: number;
}
export enum EGender {
    FEMALE = 'female',
    MALE = 'male',
    OTHER = 'other',
}
export interface IEmployeeForListPageDTO {
    id: number;
    firstName: string;
    lastName: string;
    description: string;
}
export interface IAddEmployeeDTO {
    firstname: string;
    lastname: string;
    email: string;
    gender: EGender;
    permissionGroup: IReference;
    permissions: IPermissions;
}
export interface IEmployeeSuggestedCompetence {
    id: number;
    title: string;
    level: number;
    description: string;
    employee: IEmployeeCoverage;
}

// export interface IEmployeeGoals
// {
//     wantedCompetences: IEmployeeWantedCompetenceStatus
// }

// export interface IEmployeeWantedCompetenceStatus
// {
//     id: number
//     title: string
//     level: number
//     levelTitle
// }

export interface IEmployeeSuggestedSkill {
    id: number;
    title: string;
    description: string;
}
export interface ISimilarUserDTO extends IReference {
    id: number;
    match: number;
}
